/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ScholarshiptypeId202,
  PutApiV1ScholarshiptypeId400,
  PutApiV1ScholarshiptypeId401,
  PutApiV1ScholarshiptypeId404,
  PutApiV1ScholarshiptypeId500,
  PutApiV1ScholarshiptypeIdMutationRequest,
  PutApiV1ScholarshiptypeIdMutationResponse,
  PutApiV1ScholarshiptypeIdPathParams,
} from "../../types/scholarshipTypeRegistroController/PutApiV1ScholarshiptypeId.ts";
import { scholarshipTypeFileRequestViewModelSchema } from "../scholarshipTypeFileRequestViewModelSchema.ts";
import { scholarshipTypeViewModelSchema } from "../scholarshipTypeViewModelSchema.ts";

export const putApiV1ScholarshiptypeIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1ScholarshiptypeIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1ScholarshiptypeId202Schema = z.lazy(
  () => scholarshipTypeViewModelSchema,
) as unknown as ToZod<PutApiV1ScholarshiptypeId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ScholarshiptypeId400Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshiptypeId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ScholarshiptypeId401Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshiptypeId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ScholarshiptypeId404Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshiptypeId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ScholarshiptypeId500Schema =
  z.any() as unknown as ToZod<PutApiV1ScholarshiptypeId500>;

export const putApiV1ScholarshiptypeIdMutationRequestSchema = z.object({
  CompanyId: z.optional(z.number().int()),
  Description: z.optional(z.string()),
  Instruction: z.optional(z.string()),
  HasFixedValue: z.optional(z.boolean()),
  Percentage: z.optional(z.number()),
  ExemptRegistrationValue: z.optional(z.boolean()),
  Files: z.optional(
    z.array(z.lazy(() => scholarshipTypeFileRequestViewModelSchema)),
  ),
}) as unknown as ToZod<PutApiV1ScholarshiptypeIdMutationRequest>;

export const putApiV1ScholarshiptypeIdMutationResponseSchema = z.lazy(
  () => putApiV1ScholarshiptypeId202Schema,
) as unknown as ToZod<PutApiV1ScholarshiptypeIdMutationResponse>;
